import React, { useRef } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { Doughnut, Bar } from "react-chartjs-2";
import SchoolIcon from "@mui/icons-material/School";

const LevelDistribution = ({ levelStats, onBarClick, onLevelClick }) => {
  const levelChartRef = useRef(null);

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} md={4}>
        <Paper
          elevation={2}
          sx={{ p: 3, height: "100%", borderRadius: "12px" }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 2, fontWeight: "bold", color: "#9c27b0" }}
          >
            Level Distribution
          </Typography>
          <div style={{ height: 250 }}>
            <Doughnut
              data={levelStats.chartData}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: "right",
                    labels: {
                      boxWidth: 12,
                      font: {
                        size: 10,
                      },
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        const label = context.label || "";
                        const value = context.raw || 0;
                        const total =
                          context.chart.data.datasets[0].data.reduce(
                            (a, b) => a + b,
                            0
                          );
                        const percentage = Math.round((value / total) * 100);
                        return `${label}: ${value} (${percentage}%)`;
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12} md={8}>
        <Paper
          elevation={2}
          sx={{ p: 3, height: "100%", borderRadius: "12px" }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 2, fontWeight: "bold", color: "#9c27b0" }}
          >
            Staff by Level (Click bars to view details)
          </Typography>
          <div style={{ height: 250 }}>
            <Bar
              ref={levelChartRef}
              data={levelStats.barChartData}
              options={{
                maintainAspectRatio: false,
                onClick: onBarClick,
                scales: {
                  y: {
                    beginAtZero: true,
                    ticks: {
                      precision: 0,
                    },
                  },
                  x: {
                    ticks: {
                      font: {
                        size: 10,
                      },
                      maxRotation: 45,
                      minRotation: 45,
                    },
                  },
                },
              }}
            />
          </div>
        </Paper>
      </Grid>

      {/* Level Count Boxes */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={2}>
            <Paper
              elevation={2}
              sx={{
                p: 2,
                textAlign: "center",
                borderRadius: "12px",
                backgroundColor: "rgba(153, 102, 255, 0.9)",
                color: "white",
              }}
            >
              <SchoolIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                {levelStats.sortedLevels.length}
              </Typography>
              <Typography variant="body2">Total Levels</Typography>
            </Paper>
          </Grid>

          {levelStats.sortedLevels.slice(0, 9).map((levelName, index) => (
            <Grid item xs={6} sm={4} md={2} key={levelName}>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  textAlign: "center",
                  borderRadius: "12px",
                  border: "1px solid #eee",
                  cursor: "pointer",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  },
                }}
                onClick={() => onLevelClick(levelName)}
              >
                <SchoolIcon
                  sx={{ fontSize: "2rem", mb: 1, color: "#9c27b0" }}
                />
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  {levelStats.counts[levelName]}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.85rem",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {levelName}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LevelDistribution;
